import { Marker as GoogleMarker } from '@vis.gl/react-google-maps'
import marker from 'public/images/maps/marker.svg'
import { useMemo, type ComponentProps } from 'react'

export const Marker = (
  props: Omit<ComponentProps<typeof GoogleMarker>, 'icon'> & {
    scaledSize?: number
  },
) => {
  const scaledSize = useMemo(() => {
    return props.scaledSize ? new google.maps.Size(props.scaledSize, props.scaledSize) : undefined
  }, [props.scaledSize])

  return (
    <GoogleMarker
      icon={{
        url: marker.src,
        scaledSize,
      }}
      {...props}
    />
  )
}
